import { useEffect, useState, useRef } from "react";
import {
  Grid,
  Box,
  Typography,
  Container,
  Stack,
  SvgIcon,
  Divider,
  FormControl,
  TextField,
  Checkbox,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  LoginSocialGoogle,
  LoginSocialFacebook,
  LoginSocialTwitter,
  LoginSocialGithub,
  LoginSocialLinkedin,
  IResolveParams,
} from "reactjs-social-login";
import { useGoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import { object, string, TypeOf } from "zod";
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate, useLocation } from "react-router-dom";
import { LoadingButton } from "@mui/lab";

import { ReactComponent as GoogleIcon } from "../../assets/ico_google.svg";
import { ReactComponent as FacebookIcon } from "../../assets/ico_facebook.svg";
import { ReactComponent as TwitterIcon } from "../../assets/ico_twtter.svg";
import { ReactComponent as GithubIcon } from "../../assets/ico_github.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/ico_linkedin.svg";

import BackSignup from "../../assets/back_signup.png";
import Logo from "../../assets/logo_white.png";

import {
  useSignupUserMutation,
  useSocialAuthMutation,
  useSigninUserMutation
} from "../../redux/api/authApi";
import { useGeneratedbusinessurlblogsMutation } from '../../redux/api/promptApi';
import { useAppDispatch } from "../../redux/store";
import { setModule } from "../../redux/features/genieSlice";
import { useSubscribeNewsMutation } from "../../redux/api/authApi";
import { useUnSubscribepaymentMutation } from "../../redux/api/authApi";
import img54 from '../../assets/newimg/logo.png';
import { setCookie } from "utils/storageUtils";
import { useLazyCreateCheckoutSessionQuery } from "../../redux//api/subscriptionApi";
import OceshaLogo from '../../assets/ocesha_images/ocesha_logo.png';
import axios from "axios";
import EnrollSuccessDialog from "../traffic_monster/campaigns/EnrollSuccessDialog";

const newsSubscribeform = object({
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  status: string(),
})

export type NewsSubscriptionForm = TypeOf<typeof newsSubscribeform>

const signupSchema = object({
  first_name: string().min(1, "Full name is required"),
  last_name: string().min(1, "Last name is required"),
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  password: string()
    .min(1, "Password is required")
    .min(8, "Password must be more than 8 characters"),
  passwordConfirm: string().min(1, "Please confirm your password"),
  appsumo_coupon_code: string(),
  tier: string(),
  role: string().optional()
}).refine((data) => data.password === data.passwordConfirm, {
  path: ["passwordConfirm"],
  message: "Passwords do not match",
});

export type SignupInput = TypeOf<typeof signupSchema>;

const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";

const SignupPage = () => {
  const location = useLocation();
  const { CreatingfromLanding } = location.state || {};
  const { UrlfromLanding } = location.state || {};
  const { TextfromLanding } = location.state || {};
  const { YoutubeUrlfromLanding } = location.state || {};
  const { videoNamefromLanding } = location.state || {};
  const { DirectSignup } = location.state || {};
  const { DirectFreeSignup } = location.state || {};
  const { CreatingCourseFromLanding } = location.state || {};
  const role = location.state?.role || 'user';
  const newAccntFromSignin = location.state?.newAccntFromSignin || 'false';
  const searchParams = new URLSearchParams(location.search);
  const originParam = searchParams.get("origin") || "";

  const widgetRef = useRef<HTMLDivElement>(null);

  const [termsCheck, setTermsCheck] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [authSocial, socialState] = useSocialAuthMutation();
  const [signupUser, signupState] = useSignupUserMutation();
  const [signinUser, signinState] = useSigninUserMutation();
  const [tuseremail, settUseremail] = useState('');
  const [tuserpass, settUserpass] = useState('');
  const [generatedBlogDetail, setGeneratedBlogDetail] = useState<any>();
  const [generatedBusinessUrlBlogsMutation] = useGeneratedbusinessurlblogsMutation();
  const [createCheckoutSession, checkoutState] = useLazyCreateCheckoutSessionQuery();

  const appsumoCouponCode = localStorage.getItem("appsumo_coupon_code") || '';
  const partnerName = localStorage.getItem("partner_name") || "";
  const tier = localStorage.getItem("tier") || '0';

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const methods = useForm<SignupInput>({
    resolver: zodResolver(signupSchema),
    defaultValues: {
      appsumo_coupon_code: appsumoCouponCode,
      tier: tier,
      first_name: '',
      last_name: "",
    }
  });

  const REDIRECT_URI = window.location.href;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const [enrollSuccessOpen, setEnrollSuccessOpen] = useState(false);

  // useEffect(() => {
  //   if (socialState.isSuccess) {
  //     toast.success("Social signup success");
  //     localStorage.setItem("logged_in", "true");
  //     if (socialState.data.role === "user") {
  //       localStorage.setItem("module", "SMART CONTRACTS");
  //       dispatch(setModule("SMART CONTRACTS"));
  //       navigate("/codegenie/smart_contracts");
  //     } else {
  //       navigate("/admin/dashboard");
  //     }
  //   }
  //   if (socialState.isError) {
  //     if (Array.isArray((socialState.error as any).data.detail)) {
  //       (socialState.error as any).data.detail.map((el: any) =>
  //         toast.error(`${el.loc[1]} ${el.msg}`)
  //       );
  //     } else toast.error((socialState.error as any).data.detail);
  //   }
  // }, [socialState]);
  useEffect(() => {
    if (socialState.isSuccess) {
      const data = socialState.data;
      handleAuthSuccess(data);
    }

    if (socialState.isError) {
      const err: any = socialState.error;

      if (typeof err?.data === "string") {
        toast.error(err.data);
      }


      else if (err?.data?.detail) {
        if (Array.isArray(err.data.detail)) {
          err.data.detail.forEach((el: any) => {
            toast.error(`${el.loc?.[1] || ""} ${el.msg}`);
          });
        } else {
          toast.error(err.data.detail);
        }
      }


      else {
        toast.error("Server error. Please try again.");
      }

      console.error("SOCIAL ERROR:", err);
    }
  }, [socialState]);

  const user_email = localStorage.getItem('user_email') ?? '';


  useEffect(() => {
    const fetchData = async () => {
      // if (blogGenerated === 'true') {
      try {
        const response = await generatedBusinessUrlBlogsMutation({ userid: user_email, createddate: '', createddate_to: '' });
        if ('data' in response) {
          const { data } = response.data;
          setGeneratedBlogDetail(data);
          console.log('data from variable=>', generatedBlogDetail);
        } else if ('error' in response) {

          const { error } = response;
          console.log('Error:', error);
        }
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }
      // }
    };

    fetchData();
  }, [generatedBusinessUrlBlogsMutation, user_email]);

  useEffect(() => {
    console.log(generatedBlogDetail);
  }, [generatedBlogDetail]);


  useEffect(() => {
    if (signupState.isSuccess) {
      toast.success("User created successfully");
      localStorage.setItem("logged_in", "true");
      localStorage.setItem("signedup", 'true');
      /* calling signin api directly here */
      const email = signupState.originalArgs?.email;
      const password = signupState.originalArgs?.password;
      if (email && password) {
        signinUser({ email, password, sourcefrom: "signup" } as any);
      }
      /*  */
      // handleSigninSuccess(signupState);
      // navigate("/signin", {state: {CreatingfromLanding: CreatingfromLanding, UrlfromLanding: UrlfromLanding}});
      // navigate("/verify", { state: { appsumo_coupon_code: localStorage.getItem('appsumo_coupon_code') || '' } });
    }
    if (signupState.isError) {
      if (Array.isArray((signupState.error as any).data.detail)) {
        (signupState.error as any).data.detail.map((el: any) =>
          toast.error(`${el.loc[1]} ${el.msg}`)
        );
      } else toast.error((signupState.error as any).data.detail);
      localStorage.setItem('user exists', 'true');
      if (localStorage.getItem('user exists') === 'true') {
        localStorage.setItem("logged_in", "false");
        localStorage.removeItem("payment");
        localStorage.removeItem("msg");
        localStorage.removeItem("complexity");
        localStorage.removeItem("module");
        localStorage.removeItem("subscription_level");
        localStorage.removeItem("free_plan");
        localStorage.removeItem("userRole");
        localStorage.removeItem('user exists')
        //navigate('/signin');
      }
    }

  }, [signupState]);

  useEffect(() => {
    if (signinState.isSuccess || signinState.isError) {
      handleSigninSuccess(signinState);
    }
  }, [signinState]);


  /* const handleSigninSuccess = (signinState: any) => {
    if (signinState.isSuccess) {
      localStorage.clear();

      localStorage.setItem("logged_in", "true");
      localStorage.setItem("free_plan", signinState.data.free_plan?.toString());
      localStorage.setItem("remaining_wish_count", signinState.data.remaining_wish_count?.toString());
      localStorage.setItem('FirstLogin', 'True');
      const subscriptionLevel = signinState.data.subscription_level || '';
      if (appsumoCouponCode !== '') {
        localStorage.setItem("subscription_level", 'level_0a');
      } else {
        localStorage.setItem("subscription_level", subscriptionLevel);
      }
      localStorage.setItem("user_email", signinState.data.user_email || '');
      if (signinState?.data?.user_email) {
        setCookie("user_email", signinState.data.user_email);
      }
      localStorage.setItem('userRole', signinState.data.role);
      localStorage.setItem('payment', '');
      if (CreatingfromLanding === 'true') {
        localStorage.setItem('CreatingfromLanding', CreatingfromLanding);
        if (UrlfromLanding) {
          localStorage.setItem('UrlfromLanding', UrlfromLanding);
        } else if (YoutubeUrlfromLanding) {
          localStorage.setItem('YoutubeUrlfromLanding', YoutubeUrlfromLanding);
        }
        else if (TextfromLanding) {
          localStorage.setItem('uploadedText', TextfromLanding);
        }
      }
      console.log(signinState.data.role);

      if ((signinState.data.role === "user" && (appsumoCouponCode !== '' || DirectSignup === 'true'))) {
        localStorage.setItem('DirectSignup', DirectSignup);
        localStorage.setItem('activeItem', 'createblog');
        const username = localStorage.getItem('user_name') || '';
        localStorage.setItem("subscription_level", "level_0a");
        navigate('/codegenie/new-campaign');
      } else if ((signinState.data.role === "user" && DirectSignup === 'true') || (signinState.data.role === "user" && newAccntFromSignin === 'true')) {
        localStorage.setItem('DirectSignup', DirectSignup);
        localStorage.setItem('activeItem', 'blogs');
        navigate('/codegenie/generated-blogs');
      } else if (signinState.data.role === "user") {
        console.log(generatedBlogDetail?.length);

        navigate('/codegenie/dashboard');

      }
      else {
        navigate("/admin/dashboard");
      }
    }
    if (signinState.isError) {
      localStorage.setItem("logged_in", "false");

      if (Array.isArray((signinState.error as any).data.detail)) {
        (signinState.error as any).data.detail.map((el: any) =>
          toast.error(`${el.loc[1]} ${el.msg}`)
        );
      } else toast.error((signinState.error as any).data.detail);
    }
  }; */
  //   const handleSigninSuccess = (signinState: any) => {
  //     if (signinState.isSuccess) {

  //       const savedCourseId = localStorage.getItem("selected_course_id");

  //     localStorage.clear();

  //     if (savedCourseId) {
  //       localStorage.setItem("selected_course_id", savedCourseId);
  //     }

  //       localStorage.setItem("logged_in", "true");
  //       localStorage.setItem("free_plan", signinState.data.free_plan?.toString());
  //       localStorage.setItem(
  //         "remaining_wish_count",
  //         signinState.data.remaining_wish_count?.toString()
  //       );
  //       localStorage.setItem("FirstLogin", "True");

  //       const subscriptionLevel = signinState.data.subscription_level || "";
  //       localStorage.setItem(
  //         "subscription_level",
  //         appsumoCouponCode !== "" ? "level_0a" : subscriptionLevel
  //       );

  //       localStorage.setItem("user_email", signinState.data.user_email || "");
  //       if (signinState?.data?.user_email) {
  //         setCookie("user_email", signinState.data.user_email);
  //       }

  //       localStorage.setItem("userRole", signinState.data.role);
  //       localStorage.setItem("payment", "");

  //       const fromSignUp =
  //         DirectSignup === "true" ||
  //         newAccntFromSignin === "true" ||
  //         appsumoCouponCode !== "";

  //       /* navigate("/codegenie/new-course", {
  //         state: {
  //           FromSignUp: "true"
  //         }
  //       }); */
  //      const savedCourseId = localStorage.getItem("selected_course_id");
  // const userRole = signinState.data.role;

  // if (userRole === "student") {
  //   navigate("/codegenie/course-detail", {
  //     state: { courseId: savedCourseId }
  //   });
  //   localStorage.removeItem("selected_course_id");
  // }

  // else if (userRole === "user") {
  //   navigate("/pricing", {
  //     state: { FromSignUp: "true" }
  //   });
  // }

  // else {
  //   navigate("/admin/dashboard");
  // }

  //       return;
  //     }

  //    if (signinState.isError) {
  //   localStorage.setItem("logged_in", "false");

  //   const errorData = (signinState.error as any)?.data;

  //   if (errorData?.detail) {
  //     if (Array.isArray(errorData.detail)) {
  //       errorData.detail.forEach((el: any) => {
  //         toast.error(`${el.loc?.[1] || ""} ${el.msg}`);
  //       });
  //     } else {
  //       toast.error(errorData.detail);
  //     }
  //   } else {
  //     toast.error("Login failed. Please try again.");
  //   }
  // }
  //   };

  // const handleSigninSuccess = (signinState: any) => {
  //   if (signinState.isSuccess) {
  //     // keep selected course id before clearing storage
  //     const savedCourseId = localStorage.getItem("selected_course_id");
  //     const redirect = localStorage.getItem("redirectAfterLogin");

  //     localStorage.clear();

  //     if (savedCourseId) {
  //       localStorage.setItem("selected_course_id", savedCourseId);

  //     }
  //     localStorage.setItem("logged_in", "true");

  //     localStorage.setItem(
  //       "free_plan",
  //       signinState.data.free_plan?.toString()
  //     );

  //     localStorage.setItem(
  //       "remaining_wish_count",
  //       signinState.data.remaining_wish_count?.toString()
  //     );

  //     localStorage.setItem("FirstLogin", "True");

  //     const subscriptionLevel = signinState.data.subscription_level || "";

  //     localStorage.setItem(
  //       "subscription_level",
  //       appsumoCouponCode !== "" ? "level_0a" : subscriptionLevel
  //     );

  //     localStorage.setItem("user_email", signinState.data.user_email || "");

  //     if (signinState?.data?.user_email) {
  //       setCookie("user_email", signinState.data.user_email);
  //     }

  //     localStorage.setItem("userRole", signinState.data.role);
  //     localStorage.setItem("payment", "");

  //     localStorage.setItem(
  //       "partner_name",
  //       signinState.data.partner || ""
  //     );

  //     localStorage.setItem(
  //       "partner_type",
  //       signinState.data.partner_type || ""
  //     );

  //     const userRole = signinState.data.role;

  //     if (redirect === "creator_directory") {
  //       localStorage.removeItem("redirectAfterLogin");
  //       localStorage.removeItem("userRole");
  //       localStorage.setItem("userRole", "student");
  //       navigate("/codegenie/creator-directory");
  //       return;
  //     }


  //     // redirect logic
  //     if (
  //       redirect === "checkout" &&
  //       userRole === "student" &&
  //       savedCourseId
  //     ) {
  //       localStorage.removeItem("redirectAfterLogin");

  //       navigate("/codegenie/individual-course", {
  //         state: {
  //           courseId: savedCourseId,
  //           autoCheckout: true
  //         }
  //       });

  //       return;
  //     }

  //     // alert(userRole);
  //     if (userRole === "student" && savedCourseId) {
  //       localStorage.setItem("activeItem", "course")
  //       navigate("/codegenie/individual-course", {
  //         state: { courseId: savedCourseId }
  //       });
  //       toast.success("Signup success");
  //       localStorage.removeItem("selected_course_id");
  //     }

  //     else if (userRole === "user") {
  //       const courseTopic = localStorage.getItem("course_creation_topic");
  //       if (partnerName || DirectFreeSignup === "true" || courseTopic) {
  //         localStorage.setItem("payment", "Success");
  //         localStorage.setItem("expired", "false");
  //         localStorage.setItem("subscription_level", "Free");
  //         navigate('/codegenie/onboarding_page', {
  //           state: { FromSignUp: "true" }
  //         });
  //       } else {
  //         navigate("/pricing", {
  //           state: { FromSignUp: "true" }
  //         });
  //       }
  //     }

  //     else {
  //       navigate("/admin/dashboard");
  //     }

  //     return;
  //   }

  //   // error handling
  //   if (signinState.isError) {
  //     localStorage.setItem("logged_in", "false");

  //     const errorData = (signinState.error as any)?.data;

  //     if (errorData?.detail) {
  //       if (Array.isArray(errorData.detail)) {
  //         errorData.detail.forEach((el: any) => {
  //           toast.error(`${el.loc?.[1] || ""} ${el.msg}`);
  //         });
  //       } else {
  //         toast.error(errorData.detail);
  //       }
  //     } else {
  //       toast.error("Login failed. Please try again.");
  //     }
  //   }
  // };

  const handleSigninSuccess = (signinState: any) => {
    if (signinState.isSuccess) {
      // Snapshot these BEFORE clear() — reading them after clear() means
      // they're always empty, which was silently breaking the onboarding
      // redirect for users coming from the landing "create a course" flow.
      const savedCourseId = localStorage.getItem("selected_course_id");
      const redirect = localStorage.getItem("redirectAfterLogin");
      const savedCourseTopic = localStorage.getItem("course_creation_topic");
      const savedCreatingFromLanding = localStorage.getItem("CreatingfromLanding");
      const savedUploadedText = localStorage.getItem("uploadedText");
      const savedCourseType = localStorage.getItem("course_type");
      

      // localStorage.clear();
      // Save signup status BEFORE clearing localStorage
      const isDirectSignup =
        DirectSignup === "true" ||
        newAccntFromSignin === "true";

      localStorage.clear();

      if (isDirectSignup) {
        localStorage.setItem("DirectSignup", "true");
      }

      if (savedCourseId) {
        localStorage.setItem("selected_course_id", savedCourseId);
      }

      if (savedCourseType) {
          localStorage.setItem("course_type", savedCourseType);  
      }

      if (savedCourseTopic) {
        localStorage.setItem("course_creation_topic", savedCourseTopic);
        localStorage.setItem(
          "CreatingfromLanding",
          savedCreatingFromLanding || "true"
        );
        localStorage.setItem("uploadedText", savedUploadedText || savedCourseTopic);
      }

      localStorage.setItem("logged_in", "true");
      localStorage.setItem("free_plan", signinState.data.free_plan?.toString());
      localStorage.setItem(
        "remaining_wish_count",
        signinState.data.remaining_wish_count?.toString()
      );
      localStorage.setItem("FirstLogin", "True");

      const subscriptionLevel = signinState.data.subscription_level || "";
      localStorage.setItem(
        "subscription_level",
        appsumoCouponCode !== "" ? "level_0a" : subscriptionLevel
      );

      localStorage.setItem("user_email", signinState.data.user_email || "");
      if (signinState?.data?.user_email) {
        setCookie("user_email", signinState.data.user_email);
      }

      localStorage.setItem("userRole", signinState.data.role);
      localStorage.setItem("payment", "");
      localStorage.setItem("partner_name", signinState.data.partner || "");
      localStorage.setItem("partner_type", signinState.data.partner_type || "");

      const userRole = signinState.data.role;

      if (redirect === "creator_directory") {
        localStorage.removeItem("redirectAfterLogin");
        localStorage.removeItem("userRole");
        localStorage.setItem("userRole", "student");
        navigate("/codegenie/creator-directory");
        return;
      }

      if (redirect === "checkout" && userRole === "student" && savedCourseId) {
        localStorage.removeItem("redirectAfterLogin");
        navigate("/codegenie/individual-course", {
          state: { courseId: savedCourseId, autoCheckout: true },
        });
        return;
      }

      if (redirect === "enroll" && userRole === "student" && savedCourseId) {
          const newUserEmail = signinState.data.user_email;

          axios.post(`${apiUrl}/api/subscription/enroll-free-course`, null, {
              params: { course_id: savedCourseId, student_email: newUserEmail },
          })
              .then(() => {
                  localStorage.removeItem("redirectAfterLogin");
                  localStorage.removeItem("course_type");
                  localStorage.removeItem("selected_course_id");
                  setEnrollSuccessOpen(true);   // opens the popup; navigation happens on Continue
                  localStorage.setItem("activeItem", "course")
              })
              .catch((error) => {
                  console.error("Enroll error:", error?.response?.data || error);
                  toast.error(error?.response?.data?.detail || "Failed to enroll");
                  navigate("/codegenie/generated-blogs");   // don't leave the user stuck if it fails
              });

          return;
      }

      if (userRole === "student" && savedCourseId) {
        localStorage.setItem("activeItem", "course");
        navigate("/codegenie/individual-course", {
          state: { courseId: savedCourseId },
        });
        toast.success("Signup success");
        localStorage.removeItem("selected_course_id");
      } else if (userRole === "user") {
        // Landing "create a course" flow: skip the pricing page entirely,
        // enroll on Free (same values pricing.tsx sets for the Free plan),
        // and go straight to onboarding.
        const courseTopic = localStorage.getItem("course_creation_topic");
        if (partnerName || DirectFreeSignup === "true" || courseTopic) {
          localStorage.setItem("payment", "Success");
          localStorage.setItem("expired", "false");
          localStorage.setItem("subscription_level", "Free");
          navigate("/codegenie/onboarding_page", {
            state: { FromSignUp: "true" },
          });
        } else {
          // Normal direct signup: show pricing page as usual.
          navigate("/pricing", { state: { FromSignUp: "true" } });
        }
      } else {
        navigate("/admin/dashboard");
      }

      return;
    }

    if (signinState.isError) {
      localStorage.setItem("logged_in", "false");
      const errorData = (signinState.error as any)?.data;
      if (errorData?.detail) {
        if (Array.isArray(errorData.detail)) {
          errorData.detail.forEach((el: any) => {
            toast.error(`${el.loc?.[1] || ""} ${el.msg}`);
          });
        } else {
          toast.error(errorData.detail);
        }
      } else {
        toast.error("Login failed. Please try again.");
      }
    }
  };

  const handleAuthSuccess = (data: any) => {
    if (!data) return;

    const savedCourseId = localStorage.getItem("selected_course_id");
    const redirect = localStorage.getItem("redirectAfterLogin");
    const savedCourseTopic = localStorage.getItem("course_creation_topic") || (CreatingCourseFromLanding === "true" ? (location.state?.TextfromLanding || "") : "");
    const savedCourseType = localStorage.getItem("course_type"); 

    localStorage.clear();

    if (savedCourseId) {
      localStorage.setItem("selected_course_id", savedCourseId);
    }
    if (savedCourseTopic) {
      localStorage.setItem("course_creation_topic", savedCourseTopic);
      localStorage.setItem("CreatingfromLanding", "true");
      localStorage.setItem("uploadedText", savedCourseTopic);
    }

    if (savedCourseType) {
        localStorage.setItem("course_type", savedCourseType);   // ✅ NEW
    }

    // ✅ session
    localStorage.setItem("logged_in", "true");

    localStorage.setItem(
      "free_plan",
      data.free_plan?.toString() || "0"
    );

    localStorage.setItem(
      "remaining_wish_count",
      data.remaining_wish_count?.toString() || "0"
    );

    localStorage.setItem("FirstLogin", "True");

    localStorage.setItem(
      "subscription_level",
      data.subscription_level || ""
    );

    const email = data.user_email || data.email || "";

    localStorage.setItem("user_email", email);

    if (email) {
      setCookie("user_email", email);
    }

    // ✅ FIXED ROLE
    const userRole = data.role;
    localStorage.setItem("userRole", userRole);

    localStorage.setItem("payment", "");

    localStorage.setItem(
      "partner_name",
      data.partner || ""
    );

    localStorage.setItem(
      "partner_type",
      data.partner_type || ""
    );

    const registeredStatus = data.registered_status;

    //  NEW — checkout redirect, covers BOTH new and returning Google/social users
    if (redirect === "checkout" && userRole === "student" && savedCourseId) {
        localStorage.removeItem("redirectAfterLogin");
        navigate("/codegenie/individual-course", {
            state: { courseId: savedCourseId, autoCheckout: true },
        });
        return;
    }

    // redirect override
    if (redirect === "creator_directory") {
      localStorage.removeItem("redirectAfterLogin");
      navigate("/codegenie/creator-directory");
      return;
    }

    // NEW — Google/social signup enrolling in a free course
    if (redirect === "enroll" && userRole === "student" && savedCourseId) {
        axios.post(`${apiUrl}/api/subscription/enroll-free-course`, null, {
            params: { course_id: savedCourseId, student_email: email },
        })
            .then(() => {
                localStorage.removeItem("redirectAfterLogin");
                localStorage.removeItem("course_type");
                localStorage.removeItem("selected_course_id");
                setEnrollSuccessOpen(true);
            })
            .catch((error) => {
                console.error("Enroll error:", error?.response?.data || error);
                toast.error(error?.response?.data?.detail || "Failed to enroll");
                localStorage.setItem("activeItem", "course");
                navigate("/codegenie/generated-blogs");
            });
        return;
    }

    // ✅ NEW USER
    if (registeredStatus === "New") {
      if (userRole === "student" && savedCourseId) {
        navigate("/codegenie/individual-course", {
          state: { courseId: savedCourseId }
        });
        localStorage.removeItem("selected_course_id");
      } else if (partnerName || DirectFreeSignup === "true" || savedCourseTopic) {
        // Free entry points and course-creation intent skip plan selection.
        // They are enrolled on the Free plan and continue directly to onboarding.
        localStorage.setItem("payment", "Success");
        localStorage.setItem("expired", "false");
        localStorage.setItem("subscription_level", "Free");
        navigate('/codegenie/onboarding_page', {
          state: { FromSignUp: "true" }
        });
      } else {
        navigate("/pricing", {
          state: { FromSignUp: "true" }
        });
      }
      return;
    }

    // OLD USER
    if (registeredStatus === "Old") {
      toast.success("Social signin success");
      if (userRole === "user") {
        localStorage.setItem("activeItem", "dashboard");
        navigate("/codegenie/generated-blogs");
      }
      else if (userRole === "student") {
        localStorage.setItem("activeItem", "course");
        navigate("/codegenie/generated-blogs");
      }
      else {
        navigate("/admin/dashboard");
      }

      return;
    }
  };

  useEffect(() => {
    if (checkoutState.isSuccess) {
      window.location = checkoutState.data?.checkout_url;
    }
  }, [checkoutState, navigate]);

  // First useEffect
  /* useEffect(() => {
    handleSigninSuccess(signinState);
  }, [signinState]); */



  const onSubmitHandler: SubmitHandler<SignupInput> = (values) => {
    const token = (window as any).__cf_turnstile_token;

    if (!token) {
      toast.error("Please verify you are human");
      return;
    }

    // signupUser(values);
    const payload = {
      ...values,
      role: role,
      turnstileToken: token,
      origin: localStorage.getItem("signup_origin") || originParam,
      partner: partnerName,
      // Partner-referred signups are auto-enrolled on the Free plan;
      // a normal signup leaves plan selection to the pricing page.
      plan: partnerName ? "" : "Free",
    };

    signupUser(payload as any);

    localStorage.setItem("user_email", values.email);
    localStorage.setItem("user_pass", values.password);
    localStorage.setItem("user_name", values.first_name);
    //localStorage.setItem("partner_name", values.partner);
    //signinUser({ email: values.email, password: values.password });

  };



  const [subscribeVal, setSubscribeVal] = useState<NewsSubscriptionForm>({ email: '', status: '' })
  const [newsSubsctiptionMutation, newsSubscriptionState] = useSubscribeNewsMutation();


  const methodsfoot = useForm<NewsSubscriptionForm>({
    resolver: zodResolver(newsSubscribeform),
  });

  const {
    register: RegisterFoot,
    handleSubmit: handleSubmitFoot,
    formState: { errors: Errors },
  } = methodsfoot;

  const onSubmitHandlerFoot: SubmitHandler<NewsSubscriptionForm> = (values) => {
    newsSubsctiptionMutation(values);
  };


  const handleSubscribeNews = () => {
    newsSubsctiptionMutation(subscribeVal)
      .unwrap()
      .then((response) => {
        console.log('news subscription=>', response);
        const status = response.status;

        console.log(status);
        if (status === 'success') {
          toast.success(response.message);
          setSubscribeVal({
            email: '',
            status: ''
          });
        }
      })
      .catch((error) => {
        toast.error(error?.data?.detail ?? 'Something went wrong!');
        console.error('Error sending query:', error);

      });
  };

  // cloudflare captcha verification
  useEffect(() => {
    const timer = setInterval(() => {
      if ((window as any).turnstile && widgetRef.current) {
        clearInterval(timer);

        (window as any).turnstile.render(widgetRef.current, {
          sitekey: process.env.REACT_APP_CLOUDFLARE_SITE_KEY || "",
          callback: (token: string) => {
            (window as any).__cf_turnstile_token = token;
          }
        });
      }
    }, 300);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (originParam) {
      localStorage.setItem("signup_origin", originParam);
    }
  }, [originParam]);

  useEffect(() => {
    if (searchParams.get("CreatingfromLanding")) {
      localStorage.setItem("payment", "Success");
      localStorage.setItem(
        "subscription_level",
        localStorage.getItem("subscription_level") || "Free"
      );
      localStorage.setItem("expired", "false");

      localStorage.setItem("CreatingfromLanding", searchParams.get("CreatingfromLanding") || "");
      localStorage.setItem("course_creation_topic", searchParams.get("course_creation_topic") || "");
      localStorage.setItem("uploadedText", searchParams.get("uploadedText") || "");
      localStorage.setItem('digital_twin_prompt', searchParams.get("uploadedText") || "");
    }
  }, [location.search]);

  const googleLogin = useGoogleLogin({
    scope: "openid email profile",

    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );

        if (!res.ok) {
          throw new Error("Failed to fetch Google user");
        }

        const data = await res.json();
 
        authSocial({
          provider: "google",
          email: data.email || "",
          username: data.email?.split("@")[0] || "",
          name: data.name || "",
          first_name: data.given_name || "",
          last_name: data.family_name || "",
          id: data.sub,
          initial_product: "CodeGenie",
          role: (role || "user") as string,
          plan: "Free"
        });
       
      } catch (err) {
        console.error(err);
        toast.error("Google login failed");
      }
    },

    onError: () => {
      toast.error("Google login failed");
    },
  });

  return (
    <>
      {/* Header */}
      <div className="container">
        <div className="row">
          <nav className="navbar navbar-expand-md">
            <div className="container-fluid">
              <a className="navbar-brand" href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"} style={{ textAlign: 'left' }}>
                <img src={OceshaLogo} className="img-fluid" alt="" style={{ width: '5%' }}/* style={{ width: '50%' }} */ />
              </a>
            </div>
          </nav>
          {/* <hr className="mt-3" style={{ color: "#9aa0a3" }} />s */}
        </div>
      </div>
      {/*  */}
      <div className="row">{/* my-sm-5 mb-5*/}
        <div className="col-md-5 text-white text-center mt-2">
          <div className="px-sm-0 px-2">
            <div>
              <div className="Ac-1">
                <div>
                  <Grid item xs={6} position="relative">
                    <img className="signupbg" src={BackSignup} alt="Signup Background" />
                    {/* <Box
                        position="absolute"
                        left={32}
                        top={50}
                        display="flex"
                        alignItems="center"
                        gap={1}
                        width={30}
                      >
                        <img src={OceshaLogo} alt="Logo" onClick={() => navigate('/')} />
                        <Typography variant="h5" fontWeight={600} color="white" onClick={() => navigate('/')}>
                          Ocesha
                        </Typography>
                      </Box> */}
                    <Typography
                      position="absolute"
                      bottom={103}
                      left={32}
                      variant="h4"
                      fontWeight={600}
                      color="white"
                    >
                      {/* Audit, Fix, Refactor, Document any Code Within Seconds */} <br /><br />
                    </Typography>
                  </Grid>
                </div>
              </div> <br></br> <br></br>
            </div>
          </div>
        </div>
        <div className="col-md-7 my-auto">
          <div className="px-sm-0 px-2">
            <div className="sign-up" >
              <Grid
                item
                xs={5}
                display="flex"
                alignItems="center"
                justifyContent="center"

              >
                <Box className="">
                  <Typography color="text.secondary" variant="h4" fontWeight={600}>
                    Create an account
                  </Typography>
                  {/* <Typography color="text.secondary" mt={4}>
                  Sign up with social
                </Typography> */}
                  <Stack direction="column" alignItems="center" mt={4}>
                    {/* <Box
                      sx={{
                        border: "1px solid #CACBCC",
                        borderRadius: "50px",
                        padding: "10px 20px",
                        cursor: "pointer",
                        width: "240px",
                        backgroundColor: "transparent",
                      }}
                    > */}

                    {/* <LoginSocialGoogle
                        client_id={process.env.REACT_APP_GG_APP_ID || ""}
                        scope="email profile"
                        onResolve={({ provider, data }: IResolveParams) => {
                          if (data) {
                            authSocial({
                              provider: provider as string,
                              email: data?.email || "",
                              username: data?.email?.split("@")[0] || "",
                              name: data?.name || "",
                              first_name: data?.first_name || data?.name || "",
                              last_name: data?.last_name || "",
                              id: data.sub as string,
                              initial_product: "CodeGenie",
                              role: role as string,
                            });
                          }
                        }}
                        onReject={(err) => {
                          console.log("Google login error:", err);
                          toast.error("Google login failed");
                        }}
                      > */}
                    <Box
                      onClick={() => googleLogin()}
                      sx={{
                        border: "1px solid #CACBCC",
                        borderRadius: "50px",
                        padding: "12px 20px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "240px",
                        /* "&:hover": {
                          backgroundColor: "#f5f5f5",
                        }, */
                      }}
                    >
                      <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                        <GoogleIcon style={{ width: 20, height: 20 }} />
                        <Typography variant="body2">
                          Sign up with Google
                        </Typography>
                      </Stack>
                    </Box>
                    {/* </LoginSocialGoogle> */}
                    {/* </Box> */}
                  </Stack>
                  <Stack
                    flexDirection="row"
                    alignItems="center"
                    gap={1}
                    height={44}
                    mt={3}
                  >
                    <Divider sx={{ flexGrow: 1 }} />
                    <Typography>Or</Typography>
                    <Divider sx={{ flexGrow: 1 }} />
                  </Stack>
                  <FormProvider {...methods}>
                    <Box
                      component="form"
                      noValidate
                      onSubmit={handleSubmit(onSubmitHandler)}
                    >
                      <Stack gap={3}>
                        <FormControl fullWidth>
                          <Typography mb={1} color="text.secondary">
                            First Name
                          </Typography>
                          <TextField
                            {...register("first_name")}
                            placeholder="Enter first name"
                            error={!!errors["first_name"]}
                            helperText={errors["first_name"]?.message}
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <Typography mb={1} color="text.secondary">
                            Last Name
                          </Typography>
                          <TextField
                            {...register("last_name")}
                            placeholder="Enter last name"
                            error={!!errors["last_name"]}
                            helperText={errors["last_name"]?.message}
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <Typography mb={1} color="text.secondary">
                            Email address
                          </Typography>
                          <TextField
                            {...register("email")}
                            type="email"
                            placeholder="Enter your email"
                            error={!!errors["email"]}
                            helperText={errors["email"]?.message}
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <Typography mb={1} color="text.secondary">
                            Password
                          </Typography>
                          <TextField
                            {...register("password")}
                            type={showPassword ? "text" : "password"}
                            placeholder="min 8 characters"
                            error={!!errors["password"]}
                            helperText={errors["password"]?.message}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => setShowPassword((prev) => !prev)}
                                    edge="end"
                                    aria-label="toggle password visibility"
                                  >
                                    {showPassword ? (
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                                        <line x1="1" y1="1" x2="23" y2="23" />
                                      </svg>
                                    ) : (
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                        <circle cx="12" cy="12" r="3" />
                                      </svg>
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <Typography mb={1} color="text.secondary">
                            Confirm Password
                          </Typography>
                          <TextField
                            {...register("passwordConfirm")}
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Same as previous"
                            error={!!errors["passwordConfirm"]}
                            helperText={errors["passwordConfirm"]?.message}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                                    edge="end"
                                    aria-label="toggle confirm password visibility"
                                  >
                                    {showConfirmPassword ? (
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                                        <line x1="1" y1="1" x2="23" y2="23" />
                                      </svg>
                                    ) : (
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                        <circle cx="12" cy="12" r="3" />
                                      </svg>
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </FormControl>
                        <input type="hidden" {...register("appsumo_coupon_code")} value={appsumoCouponCode} />
                        <input type="hidden" {...register("tier")} value={tier} />
                        <Box display="flex" alignItems="center">
                          <Checkbox
                            value={termsCheck}
                            onChange={(e) => setTermsCheck(e.target.checked)}
                          />{" "}
                          <Typography style={{ color: '#fff' }}>
                            I agree to the{" "}
                            <Link
                              to="/terms"
                              target="_blank"
                              style={{
                                color: "#0168B5",
                              }}
                            >
                              Terms
                            </Link>
                            {" & "}
                            <Link
                              to="/privacy"
                              target="_blank"
                              style={{
                                color: "#0168B5",
                              }}
                            >
                              Privacy Policy
                            </Link>
                          </Typography>
                        </Box>
                        {/* cloudflare captcha verification */}
                        <Box mt={2}>
                          <div ref={widgetRef}></div>
                        </Box>
                        {/*  */}
                      </Stack>
                      <LoadingButton
                        fullWidth
                        sx={{
                          height: 56,
                          background:
                            "linear-gradient(90deg, #036AB7 0%, #4BA5EB 100%)",
                          color: "white",
                          mt: 4,
                        }}
                        loading={signupState.isLoading}
                        type="submit"
                        disabled={!termsCheck}
                      >
                        Sign Up
                      </LoadingButton>
                    </Box>
                  </FormProvider>
                  <Typography mt={3} style={{ color: "#fff" }}>
                    Have an account?{" "}
                    <Link
                      to="/signin"
                      style={{
                        color: "#0168B5",
                      }}
                    >
                      Sign In
                    </Link>
                  </Typography>
                </Box>
              </Grid>
            </div>
          </div>
        </div>

        <EnrollSuccessDialog
          open={enrollSuccessOpen}
          onClose={() => {
              setEnrollSuccessOpen(false);
              localStorage.setItem("activeItem", "course");
              navigate("/codegenie/generated-blogs");
          }}
      />

      </div>

    </>

  );
};

export default SignupPage;